
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/api/charts/mark-element",
      function () {
        return require("private-next-pages/x/api/charts/mark-element.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/api/charts/mark-element"])
      });
    }
  